module.exports = __webpack_public_path__ + "img/militaryBig.72ed96ad.png";